import { useSEO } from "@/lib/seo";
import PageHeader from "@/components/sections/PageHeader";
import FAQ from "@/components/sections/FAQ";
import FinalCTA from "@/components/sections/FinalCTA";

export default function FAQPage() {
  useSEO({
    title: "Frequently Asked Questions · Radiation Oncology",
    description:
      "Common questions about radiation therapy, cancer treatment planning, brachytherapy, and Dr. Anusha's practice in Hyderabad.",
    keywords:
      "Radiation Therapy FAQ, Cancer Treatment Questions Hyderabad",
    path: "/faqs",
  });

  return (
    <div data-testid="faq-page">
      <PageHeader
        eyebrow="FAQs"
        title="Clear answers to common questions."
        description="Simple, medically responsible answers about radiation oncology, cancer treatment planning and what to expect during consultation."
      />
      <FAQ variant="compact" />
      <FinalCTA />
    </div>
  );
}
